import React from "react";
import cross from "../../Assets/newAsset/cross.svg";
import mri from "../../Assets/Imagngmri.svg";
import petScan from "../../Assets/ct-scan (2).svg";
import outline from "../../Assets/Outline.svg";
import ultrasound from "../../Assets/Group 10924.svg";
import mammography from "../../Assets/mammography.svg";
import SoundAssistant from "../../Assets/Sound assistant.svg";
import { useHistory } from "react-router-dom";
import { useState, useEffect } from "react";
import "./ImagingServices.css";

const pacakgesData = [
  {
    id: 1,
    img: cross,
    title: "Routine Testing",
    desc: "Routine investigations coverage from wellness to illness",
  },
  {
    id: 2,
    img: cross,
    title: "Pathology Services",
    desc: "Super specialized department to diagnose auto immune disorders",
  },
  {
    id: 3,
    img: cross,
    title: "Genomic Testing",

    desc: "Advanced genetic testing to know your health risks",
  },
  {
    id: 4,
    img: cross,
    title: "Genomic Testing",

    desc: "Advanced genetic testing to know your health risks",
  },
];

function ImagingServices() {
  const history = useHistory();
  return (
    <div className="ImagingServicesMainNew">
      <div className="DivForMainImagingServices container">
        <div className="underDivForMainImagingServices">
          <div className="DivForParaInServices">
            <h1>Our Imaging Services</h1>
            <p>All Imaging Services Under One Roof</p>
          </div>
          <div className="DivForTwoImagingServices">
            <div
              onClick={() => {
                history.push({
                  pathname: "/imaging/health-checkup-packages",
                  type: "MRI",
                });
              }}
              className="DivForGridImagingServices"
            >
              <div className="DivForGridImages">
                <img src={mri} alt="mri" />
              </div>
              <div className="DivForGridParaImagingServices">
                <p>MRI Scan</p>
              </div>
            </div>
            <div
              onClick={() => {
                history.push({
                  pathname: "/imaging/health-checkup-packages",
                  type: "PET",
                });
              }}
              className="DivForGridImagingServices"
            >
              <div className="DivForGridImages">
                <img src={petScan} alt="mri" />
              </div>
              <div className="DivForGridParaImagingServices">
                <p>PET Scan</p>
              </div>
            </div>
            <div
              onClick={() => {
                history.push({
                  pathname: "/imaging/health-checkup-packages",
                  type: "CT",
                });
              }}
              className="DivForGridImagingServices"
            >
              <div className="DivForGridImages">
                <img src={outline} alt="mri" />
              </div>
              <div className="DivForGridParaImagingServices">
                <p>CT Scan</p>
              </div>
            </div>

            {/* <div className="DivForTwoImagingServices"> */}
            <div
              onClick={() => {
                history.push({
                  pathname: "/imaging/health-checkup-packages",
                  type: "USG",
                });
              }}
              className="DivForGridImagingServices"
            >
              <div className="DivForGridImages">
                <img src={ultrasound} alt="mri" />
              </div>
              <div className="DivForGridParaImagingServices">
                <p>Ultrasound</p>
              </div>
            </div>
            <div
              onClick={() => {
                history.push({
                  pathname: "/imaging/health-checkup-packages",
                  type: "MAM",
                });
              }}
              className="DivForGridImagingServices"
            >
              <div className="DivForGridImages">
                <img src={mammography} alt="mri" />
              </div>
              <div className="DivForGridParaImagingServices">
                <p>Mammography</p>
              </div>
            </div>
            <div
              onClick={() => {
                history.push({
                    pathname: "/imaging/health-checkup-packages",
                    type: "CAR",
                  });
              }}
              className="DivForGridImagingServices"
            >
              <div className="DivForGridImages" onClick={() => {
                history.push({
                  pathname:  "/imaging/health-checkup-packages",
                  type: "CAR"
                })
              }} >
                <img src={SoundAssistant} alt="CARDIOLOGY" />
              </div>
              <div className="DivForGridParaImagingServices">
                <p>Cardiology </p>
              </div>
            </div>
          </div>
        </div>
        {/* </div> */}
      </div>
    </div>
  );
}

export default ImagingServices;
